module.exports = __webpack_public_path__ + "static/media/logo.9e756b7e.svg";